(function () {
  'use strict';

  angular
    .module('app.cart.shipping', ['service.gmap'])

    .directive('cartShipping', function () {
      return {
        restrict: 'A',
        bindToController: {
          device: '<',
          step: '<'
        },
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$element", "$timeout", "$location", "$q", "AppService", "CartService", "HttpService", "ModalService", "RoutesService", "AccountService", "ShippingService", "ShippingCacheService", "GMaps", "angulargmContainer", "smoothScroll", "toastr", function ($scope, $rootScope, $element, $timeout, $location, $q, AppService, CartService, HttpService, ModalService, RoutesService, AccountService, ShippingService, ShippingCacheService, GMaps, angulargmContainer, smoothScroll, toastr) {
          var ctrl = this;

          var mapListerner,
            markerClusterer;

          // Translate
          var tplTranslate = {};
          $element.children('.translate').children().each(function () {
            var $this = $(this);
            tplTranslate[$this.attr('key')] = $this.html();
          });

          ctrl.NextEnabled = false;
          ctrl.NextTooltip = tplTranslate.ShippingChoice;

          getCart();

          // Cart Aside
          ctrl.toggleCart = function () {
            CartService.toggleCart(ctrl);
          };
          ctrl.toggleUpdate = function (model) {
            CartService.toggleUpdate(ctrl, model);
          };
          ctrl.submitCode = function (event) {
            if (String(ctrl.formCode.data.code) === '') return;
            $(event.target).find('.form-control').blur();
            CartService.submitCode(ctrl);
          };
          ctrl.cancelCode = function (code) {
            CartService.cancelCode(ctrl, code);
          };
          ctrl.addLoyaltyPoint = function () {
            CartService.addLoyaltyPoint(ctrl);
          };
          ctrl.cancelLoyaltyPoint = function () {
            CartService.cancelLoyaltyPoint(ctrl);
          };
          ctrl.useCredit = function (id) {
            CartService.useCredit(ctrl, id);
          };
          ctrl.cancelCredit = function (id) {
            CartService.cancelCredit(ctrl, id);
          };
          ctrl.cancelGiftCard = function (code) {
            CartService.cancelGiftCard(ctrl, code);
          };
          // End Cart Aside

          ctrl.selectItem = function (item, autoSelect) {
            if (item.Selected && !autoSelect) return;

            autoSelect = autoSelect || false;

            ShippingService.cancelGetPickUpPoints();

            ctrl.NextEnabled = true;
            ctrl.NextTooltip = '';

            _.each(ctrl.shipping.shippingList, function (shipping) {
              shipping.Selected = false;
              shipping.showMap = false;
              shipping.showDriveMap = false;
              shipping.showMobilePhone = false;
              shipping.loading = false;
              $timeout(function () {
                shipping.gmap = '';
              }, 350);
            });
            item.Selected = true;
            ctrl.itemSelected = { item: item };
            checkEnabled();

            if (!autoSelect) selectShipping(item.IDShippingGridValue);

            if (item.PickUp) {
              ctrl.ShowPointsList = true;
              ctrl.ShowPointsMap = ctrl.device.mobile ? false : true;
              ctrl.pointInfos = null;
              item.btnAction = tplTranslate.ChoisirUnAutrePoint;

              var card = ctrl.shipping.userShippingCard;
              card.fullAddress = card.Address +
                                 (card.AddressLocality !== '' ? ' ' + card.AddressLocality : '') +
                                 ' ' + card.PostCode +
                                 ' ' + card.City +
                                 ' ' + card.Country.Designation;
              item.addressSearch = card.fullAddress;
              if (!autoSelect || !item.Address) {
                searchPickUpPoints(item, card.fullAddress, card);
                if (ctrl.mobileForm && !ctrl.mobileForm.$valid) {
                  item.showMobilePhone = true;
                  var $input = $('#mobilePhone_' + item.IDShippingGridValue);
                  $input.focus();
                  setTimeout(function () {
                    $input.blur();
                  }, 100);
                  checkEnabled();
                }
              } else {
                ctrl.selectPickUpPoint(null, item, null, true);
              }
            } else if (item.Key !== 'ENLEVEMENT') {
              item.btnAction = tplTranslate.ChoisirUneAutreAdresse;
            }

            if (!autoSelect) {
              setTimeout(function () {
                smoothScroll(document.getElementById('shippingItem_' + item.IDShippingGridValue), { offset: 20 });
              }, 550);
            }
          };

          ctrl.setShowPointsList = function (value) {
            ctrl.ShowPointsList = value;
          };

          ctrl.newSearch = function (event) {
            if (ctrl.itemSelected.item.addressSearch === '') return;

            if (typeof event === 'undefined') {
              searchPickUpPoints(ctrl.itemSelected.item, ctrl.itemSelected.item.addressSearch);
            } else if (event.which === 13) {
              event.preventDefault();
              $(event.target).blur();
              searchPickUpPoints(ctrl.itemSelected.item, ctrl.itemSelected.item.addressSearch);
            }
          };

          ctrl.showPickUpPoint = function (item, point, marker) {
            point = point || _.find(item.pickUpPoints, { Id: marker.id });
            marker = marker || _.find(item.markers, { id: point.Id });

            if (ctrl.pickUpPointsSelected) {
              ctrl.pickUpPointsSelected.selected = false;
            }
            ctrl.pickUpPointsSelected = point;
            ctrl.pickUpPointsSelected.selected = true;

            scrollToPoint(marker.id);

            ctrl.itemSelected.item = item;
            ctrl.itemSelected.item.Address = point;
            ctrl.itemSelected.item.Address.Country = ctrl.itemSelected.item.Address.Country.toUpperCase();

            if (ctrl.markerSelected) {
              ctrl.markerSelected.selected = false;
            }
            ctrl.markerSelected = marker;
            ctrl.markerSelected.selected = true;
            $scope.$broadcast('gmMarkersUpdate', 'item.markers');

            if (point.OpeningHours.Monday.AM === undefined) {
              point.hasSchedule = true;
              _.each(_.filter(point.OpeningHours, function (o) {
                return angular.isObject(o);
              }), function (day) {
                if (day.OpeningAM === '0000' && day.ClosingAM === '0000' && day.OpeningPM === '0000' && day.ClosingPM === '0000') {
                  day.AM = tplTranslate.Ferme;
                  day.PM = '';
                } else if (day.OpeningPM === '0000' && day.ClosingPM === '0000' && Number(day.ClosingAM) > 1300) {
                  day.AM = day.OpeningAM.slice(0, 2) + 'h' + day.OpeningAM.slice(2);
                  day.PM = day.ClosingAM.slice(0, 2) + 'h' + day.ClosingAM.slice(2);
                } else {
                  day.AM = day.OpeningAM.slice(0, 2) + 'h' + day.OpeningAM.slice(2) + ' - ' + day.ClosingAM.slice(0, 2) + 'h' + day.ClosingAM.slice(2);
                  if (day.OpeningPM !== '0000' && day.ClosingPM !== '0000') {
                    day.PM = day.OpeningPM.slice(0, 2) + 'h' + day.OpeningPM.slice(2) + ' - ' + day.ClosingPM.slice(0, 2) + 'h' + day.ClosingPM.slice(2);
                  }
                }
              });
            }

            if (ctrl.device.mobile) {
              ctrl.pointInfos = point;
            }

            var gmapPromise = angulargmContainer.getMapPromise('map_' + item.IDShippingGridValue);
            gmapPromise.then(function (map) {
              setTimeout(function () {

                google.maps.event.removeListener(mapListerner);

                map.panTo({ lat: marker.lat, lng: marker.lng });

                if (!ctrl.device.desktop) {
                  var dif = ($('#map_' + item.IDShippingGridValue).height() / 2) - $('#pointInfos').outerHeight() - 45;
                  map.panBy(0, dif);

                  setTimeout(function () {
                    mapListerner = map.addListener('bounds_changed', function () {
                      ctrl.pointInfos = null;
                    });
                  }, 200);
                }

              });
            })
            .catch(function (error) {
              console.error(error);
            });

          };

          ctrl.closePointInfo = function () {
            ctrl.pointInfos = null;
          };

          ctrl.selectPickUpPoint = function (event, item, point, autoSelect) {
            autoSelect = autoSelect || false;
            if (event !== null) event.stopPropagation();

            if (!autoSelect) {
              selectShipping(item.IDShippingGridValue, point.Id);
              setTimeout(function () {
                smoothScroll(document.getElementById('shippingItem_' + item.IDShippingGridValue), { offset: 20 });
              }, 550);
            }

            item.showMap = false;
            item.showMobilePhone = true;
            $timeout(function () {
              item.gmap = '';
              var $input = $('#mobilePhone_' + item.IDShippingGridValue);
              $input.focus();
              setTimeout(function () {
                $input.blur();
                if (!ctrl.mobileForm.$valid) {
                  setTimeout(function () {
                    $input.focus();
                  }, 100);
                }
              }, 500);
              checkEnabled();
            }, 350);
          };

          ctrl.getMarkerOpts = function (item, marker) {
            if (marker.driveMarker) {
              return {
                icon: { url: '/img/shipping/drive-marker.png', labelOrigin: new google.maps.Point(15, 40) },
                label: { text: marker.name, fontWeight: 'bold' },
                zIndex: 1
              };
            }
            if (marker.userMarker) {
              return {
                icon: '/img/gmap/user-marker.png',
                zIndex: 1
              };
            }
            if (marker.selected) {
              return {
                title: null,
                icon: { url: '/img/shipping/' + _.camelCase(item.Key) + '-marker-active.png', labelOrigin: new google.maps.Point(20, 50) },
                label: { text: marker.name, fontWeight: 'bold' },
                zIndex: 3
              };
            }
            return {
              title: marker.name,
              icon: { url: '/img/shipping/' + _.camelCase(item.Key) + '-marker.png' },
              label: null,
              zIndex: 2
            };

          };

          ctrl.showDriveMap = function (item) {
            if (item.showDriveMap) {
              item.showDriveMap = false;
              $timeout(function () {
                item.gmap = '';
              }, 350);
              return;
            }
            item.gmap = '';
            item.loading = true;
            $timeout(function () {
              var address = item.Address.AddressLine1 +
                            (item.Address.AddressLine2 !== '' ? ' ' + item.Address.AddressLine2 : '') +
                            (item.Address.Apartment !== '' ? ' ' + item.Address.Apartment : '') +
                            (item.Address.Building !== '' ? ' ' + item.Address.Building : '') +
                            (item.Address.Complement !== '' && item.Address.Complement !== null ? ' ' + item.Address.Complement : '') +
                            ' ' + item.Address.PostCode +
                            ' ' + item.Address.City +
                            ' ' + item.Address.Country;

              GMaps.getGeoCode(address)
                .then(function (gps) {
                  GMaps.get()
                    .then(function () {
                      item.showDriveMap = true;
                      item.markers = [{
                        id: 0,
                        name: 'Testoon Châtillon',
                        lat: gps.Latitude,
                        lng: gps.Longitude,
                        driveMarker: true
                      }];
                      item.options = {
                        map: {
                          center: {
                            lat: gps.Latitude,
                            lng: gps.Longitude
                          },
                          zoom: 12,
                          styles: [{'stylers': [{'saturation': -100}, {'lightness': 50}]}]
                        }
                      };
                      item.gmap = 'gmap.tpl';
                      item.loading = false;
                    })
                    .catch(function (error) {
                      console.error(error);
                    });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }, 400);
          };

          ctrl.changeShippingAddress = function (item) {
            if (item && item.PickUp) {
              item.Selected = false;
              ctrl.selectItem(item);
            } else {
              $rootScope.$broadcast('showPageLoader', true);
              AccountService.getShippingAddresses()
                .then(function (results) {
                  AppService.getParams()
                    .then(function (params) {
                      var addresses = [
                        {
                          IDCard: params.Visitor.IDCard,
                          FullName: params.Visitor.FullName,
                          Address: params.Visitor.Address,
                          AddressApartment: params.Visitor.AddressApartment,
                          AddressBuilding: params.Visitor.AddressBuilding,
                          AddressLocality: params.Visitor.AddressLocality,
                          PostCode: params.Visitor.PostCode,
                          City: params.Visitor.City,
                          Country: {
                            Designation: params.Visitor.Country.Designation
                          },
                          Phone: params.Visitor.Phone,
                          MobilePhone: params.Visitor.MobilePhone
                        }
                      ];
                      addresses = addresses.concat(_.filter(results.addresses, { IDCardType: 7 }));
                      addresses = _.filter(addresses, function (address) {
                        return address.IDCard !== params.Cart.IDShippingCard;
                      });
                      ModalService.show(
                        '/Template/Cart/ModalSetShippingAddress',
                        {
                          device: ctrl.device,
                          addresses: addresses,
                          titles: results.titles,
                          countries: results.countries,
                          country: params.Visitor.Country,
                          action: function (card) {
                            setShippingAddress(card);
                          },
                          Phone: params.Visitor.Phone,
                          MobilePhone: params.Visitor.MobilePhone
                        },
                        null,
                        'modalSetShippingAddressCtrl'
                      );
                      $rootScope.$broadcast('showPageLoader', false);
                    });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          };

          ctrl.toggleMobilePhone = function (event, item) {
            item.editMobile = true;
            $(event.target).closest('form').find('.form-control').focus();
          };


          ctrl.focusMobilePhone = function (item) {
            if (!item.editMobile) {
              item.editMobile = true;
              ctrl.targetMobilePhone = $('#mobilePhone_' + item.IDShippingGridValue);
              if (ctrl.mobileForm && ctrl.mobileForm.MobilePhone) {
                ctrl.mobileForm.MobilePhone.$showValidation();
              }
            }
          };
          ctrl.blurMobilePhone = function (item) {
            item.editMobile = false;
          };


          ctrl.changeMobilePhone = function () {
            $timeout(function () {
              if (ctrl.mobileForm.$valid) {
                ctrl.targetMobilePhone.blur();
                updateMobilePhone();                
              }
              checkEnabled();
            });
          };
          ctrl.submitMobilePhone = function (item) {
            item.editMobile = false;
            $timeout(function () {
              ctrl.mobileForm.MobilePhone.$showValidation();
            });
            updateMobilePhone();
          };

          ctrl.submitPickUpPoint = function () {
            $location.path(ctrl.nextStep);
          };

          ctrl.saveComment = function () {
            ctrl.commentLoading = true;
            CartService.saveComment(ctrl.cart.Comment)
              .then(function (response) {
                if (response && response.status === 'OK') {
                  updateCart(response.results);
                  var message = ctrl.cart.Comment === '' ? tplTranslate.CommentDeleted : tplTranslate.CommentSaved;
                  toastr.success('', message, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
                ctrl.commentLoading = false;
              })
              .catch(function (error) {
                console.error(error);
              });
          };

          ctrl.convertToQuotation = function () {
            AppService.getParams()
              .then(function (params) {
                if (!params.IsLogged) {
                  ModalService.show(
                    '/Template/Cart/ModalConvertQuotationConnect',
                    {
                      action: function () {
                        ctrl.convertToQuotation();
                      }
                    },
                    null,
                    'convertQuotationConnectModalCtrl'
                  );
                } else {
                  $scope.$emit('showPageLoader', true);
                  HttpService.post({
                    url: 'Cart/ConvertToQuotation',
                    data: {}
                  })
                    .then(function (response) {
                      AppService.getTranslate()
                        .then(function (translate) {
                          if (response.status === 'OK') {
                            toastr.success('', translate.messages.ConvertToQuotationOK, {
                              allowHtml: true,
                              extraData: {
                                template: 'toast_message.tpl'
                              }
                            });
                            if (!params.IsManagementWebCartTracking) {
                              $rootScope.$broadcast('userUpdate');
                            }
                            $location.path(AccountService.getLinks().AccountQuotations);
                          } else {
                            toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                              allowHtml: true,
                              extraData: {
                                template: 'toast_message.tpl'
                              }
                            });
                          }
                          ctrl.NextEnabled = false;
                          $scope.$emit('showPageLoader', false);
                        });
                    });
                }
              });
          };

          // Functions
          $scope.$on('cartUpdate', setNextLink);

          ctrl.$onDestroy = function () {
            ShippingService.cancelGetPickUpPoints();
          };

          // Functions

          function setNextLink() {
            CartService.updateStepsCart(ctrl);

            var _routes = RoutesService.get();
            ctrl.nextStep = ctrl.cart.RestToPay === 0 ? '/' + _routes.CartValidation.url : '/' + _routes.CartPayment.url;
          }

          function checkAddress() {
            ctrl.loading = true;
            HttpService.get({
              url: '/AccountCheckAddress',
              cache: false
            })
            .then(function (response) {
              if (response.status === 'OK') {
                getShippingList();
              } else {
                AppService.getParams()
                  .then(function (params) {
                    ModalService.show(
                      '/Template/Cart/ModalSetUserAddress',
                      {
                        titles: response.titles,
                        countries: response.countries,
                        IDTitle: params.Visitor.Title.IDTitle || '',
                        FirstName: params.Visitor.FirstName,
                        LastName: params.Visitor.LastName,
                        Address: params.Visitor.Address,
                        AddressApartment: params.Visitor.AddressApartment,
                        AddressBuilding: params.Visitor.AddressBuilding,
                        AddressLocality: params.Visitor.AddressLocality,
                        PostCode: params.Visitor.PostCode,
                        City: params.Visitor.City,
                        Country: (params.Visitor.Country && params.Visitor.Country.IDCountry && params.Visitor.Country.IDCountry !== 0) ?  params.Visitor.Country : _.find(response.countries, { 'IDCountry': 1 }),
                        Phone: params.Visitor.Phone,
                        MobilePhone: params.Visitor.MobilePhone
                      },
                      null,
                      'modalSetUserAddressCtrl',
                      null,
                      ctrl.device,
                      null,
                      checkAddressOnClose
                    );
                  });
              }
            })
            .catch(function (error) {
              console.error(error);
            });
          }

          function checkAddressOnClose() {
            AppService.getParams(true)
              .then(function () {
                HttpService.get({
                  url: '/AccountCheckAddress',
                  cache: false
                })
                .then(function (response) {
                  if (response.status === 'OK') {
                    getShippingList();
                  } else {
                    var _routes = RoutesService.get();
                    $location.path('/' + _routes.Cart.url);
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function getShippingList() {
            ShippingService.getList()
              .then(function (response) {
                if (response.status === 'OK') {
                  ctrl.shipping = response.results;
                  _.each(ctrl.shipping.shippingList, function (item) {
                    item.imgSrc = '/img/shipping/' + _.camelCase(item.Key) + '.png';
                    if (item.Key === 'ENLEVEMENT' && item.TTCPrice === 0) {
                      item.FinalPrice = 'gratis';
                    } else if (ctrl.cart.PortOffert || item.TTCPrice === 0) {
                      item.FinalPrice = 'free';
                    }
                    if (ctrl.cart.Shipping) {
                      if (item.IDShippingGridValue === ctrl.cart.Shipping.IDShippingGridValue) ctrl.selectItem(item, true);
                    }
                  });
                  if (!ctrl.shipping.shippingList.length) {
                    ctrl.NextEnabled = false;
                  }
                } else {
                  console.error(response.status);
                }
                ctrl.loading = false;
                $rootScope.$broadcast('showPageLoader', false);
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function getCart() {
              AppService.getParams()
              .then(function (data) {
                updateCart(data, true);
                setNextLink();

                ctrl.originalComment = ctrl.cart.Comment;
                if (ctrl.cart.Comment !== '') ctrl.openComment = true;

                checkAddress();
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function updateCart(data, noevent) {
            CartService.update(ctrl, data, noevent);
          }

          function loadClusterer() {
            var deferred = $q.defer();
            GMaps.getClusterer()
              .then(function () {
                deferred.resolve('ok');
              })
              .catch(function (error) {
                console.error(error);
              });
            return deferred.promise;
          }

          function searchPickUpPoints(item, address, card) {
            item.loading = true;
            address = _.replace(address, / /g, '+');
            GMaps.getGeoCode(address)
              .then(function (gps) {
                searchGpsPickUpPoints(item, gps);

                var $autocomplete = $('#autocompleteGmap_' + item.IDShippingGridValue);
                if (!$autocomplete.data('init')) {
                  $autocomplete.data('init', true);
                  /*
                  var autocomplete = new google.maps.places.Autocomplete($autocomplete[0], {
                    types: ['geocode'],
                    componentRestrictions: { country: 'be' }
                  });
                  */
                  var autocomplete = new google.maps.places.Autocomplete($autocomplete[0], {
                    types: ['geocode'],
                    componentRestrictions: { country: 'fr' }
                  });

                  google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    $scope.$apply(function () {
                      item.addressSearch = $autocomplete.val();
                      ctrl.newSearch();
                    });
                  });
                }

                if (window.location.hostname === 'localhost' || window.location.protocol === 'https:') {
                  if (navigator.geolocation && !ctrl.geolocation) {
                    ctrl.geolocation = true;
                    ctrl.getGeolocation = function () {
                      item.loading = true;

                      var defer = $q.defer();
                      defer.promise.then(function (position) {
                        var pos = {
                          lat: position.coords.latitude,
                          lng: position.coords.longitude
                        };
                        GMaps.getGeoCodeByGps(pos)
                          .then(function (response) {
                            item.addressSearch = response.address;
                            searchGpsPickUpPoints(item, response.gps);
                          })
                          .catch(function (error) {
                            console.error(error);
                          });
                      }, function (data) {
                        item.loading = false;
                      });

                      navigator.geolocation.getCurrentPosition(function (position) {
                        defer.resolve(position);
                      }, function (err) {
                        defer.reject(err);
                      });

                      $timeout(function () {
                        defer.reject('timed out');
                      }, 5000);

                    };
                  }
                }
              })
              .catch(function (response) {
                if (response.status === 'ZERO_RESULTS') {
                  if (card) {
                    searchPickUpPoints(item, card.PostCode + ' ' + card.City + ' ' + card.Country.Designation);
                  } else {
                    searchPickUpPoints(item, '75000');
                  }
                } else {
                  console.error(response);
                }
              });
          }
          function searchGpsPickUpPoints(item, gps) {
            var cache = ShippingCacheService.get(item.key + '|' + gps.Latitude + '|' + gps.Longitude);
            if (cache) {
              setTimeout(function () {
                resultsPickUpPoints(item, gps, cache);
              }, 350);
              return;
            }

            var pos = {
              lat: gps.Latitude,
              lng: gps.Longitude
            };
            GMaps.getGeoCodeByGps(pos)
              .then(function (response) {
                ShippingService.getPickUpPoints(item.Key, response.gps)
                  .then(function (data) {
                    resultsPickUpPoints(item, gps, data);
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              });

          }
          function resultsPickUpPoints(item, gps, data) {
            item.pickUpPoints = data;
            var bounds = new google.maps.LatLngBounds();
            item.markers = [];

            if (!item.pickUpPoints.length) {
              item.loading = false;
              return;
            }

            _.each(item.pickUpPoints, function (point) {
              point.Distance = point.Distance * 1000;
              if (point.Distance >= 1000) {
                var km = (point.Distance / 1000).toFixed(2);
                km = (km === Math.floor(km)) ? Math.floor(km) : km;
                point.DistanceKm = String(km).replace('.', ',');
              }
              point.selected = item.Address ? point.Id === item.Address.Id : false;
              item.markers.push({
                id: point.Id,
                name: point.Name,
                lat: point.Coordinate.Latitude,
                lng: point.Coordinate.Longitude,
                selected: point.selected
              });
              if (point.selected) {
                ctrl.pickUpPointsSelected = point;
                ctrl.markerSelected = _.find(item.markers, { id: point.Id });
                $timeout(function () {
                  ctrl.showPickUpPoint(item, null, ctrl.markerSelected);
                }, 350);
              }
              bounds.extend(new google.maps.LatLng(point.Coordinate.Latitude, point.Coordinate.Longitude));
            });

            item.showMap = true;
            //
            item.options = {
              map: {
                center: bounds.getCenter(),
                styles: [{ 'stylers': [{ 'saturation': -100 }, { 'lightness': 50 }] }]
              }
            };

            item.gmap = 'gmap.tpl';

            var gmapPromise = angulargmContainer.getMapPromise('map_' + item.IDShippingGridValue);
            gmapPromise.then(function (map) {
              setTimeout(function () {
                google.maps.event.trigger(map, 'resize');
                map.fitBounds(bounds);

                loadClusterer()
                  .then(function () {
                    var markers = angulargmContainer.getMarkers('map_' + item.IDShippingGridValue);
                    for (var i = 0; i < markers.length; i++) {
                      markers[i].setMap(null);
                    }
                    angulargmContainer.clearMarkers('map_' + item.IDShippingGridValue);
                    $scope.$broadcast('gmMarkersRedraw', 'item.markers');

                    var options = {
                      gridSize: 50,
                      maxZoom: 15,
                      styles: [
                        {
                          width: 53,
                          height: 53,
                          url: '/img/shipping/' + _.camelCase(item.Key) + '_m1.png',
                          textColor: '#fff'
                        },
                        {
                          width: 56,
                          height: 56,
                          url: '/img/shipping/' + _.camelCase(item.Key) + '_m2.png',
                          textColor: '#fff'
                        },
                        {
                          width: 66,
                          height: 66,
                          url: '/img/shipping/' + _.camelCase(item.Key) + '_m3.png',
                          textColor: '#fff'
                        },
                        {
                          width: 78,
                          height: 78,
                          url: '/img/shipping/' + _.camelCase(item.Key) + '_m4.png',
                          textColor: '#fff'
                        },
                        {
                          width: 90,
                          height: 90,
                          url: '/img/shipping/' + _.camelCase(item.Key) + '_m5.png',
                          textColor: '#fff'
                        }
                      ]
                    };
                    if (markerClusterer) {
                      markerClusterer.clearMarkers();
                    }
                    markers = angulargmContainer.getMarkers('map_' + item.IDShippingGridValue);
                    markerClusterer = new MarkerClusterer(map, markers, options);
                    setTimeout(function () {
                      item.markers.push({
                        id: '0',
                        lat: gps.Latitude,
                        lng: gps.Longitude,
                        userMarker: true
                      });
                      bounds.extend(new google.maps.LatLng(gps.Latitude, gps.Longitude));
                      map.fitBounds(bounds);
                      if (item.markers.length === 1) {
                        map.setZoom(5);
                      }
                      $scope.$broadcast('gmMarkersUpdate', 'item.markers');
                    }, 500);
                  });
              });
            })
            .catch(function (error) {
              console.error(error);
            });

            //
            item.loading = false;
          }

          function scrollToPoint(id) {
            var $list = $('#pointsListInner'),
              $point = $('#point_' + id);

            setTimeout(function () {
              $list.animate({ scrollTop: $list.scrollTop() + $point.position().top }, 350);
            }, 400);
          }

          function setShippingAddress(card) {
            $rootScope.$broadcast('showPageLoader', true);
            HttpService.post({
              url: '/Shipping/SetShippingAddress',
              data: card.IDCard
            })
            .then(function (response) {
              if (response.status === 'OK') {
                updateCart(response.results);
                getShippingList();
              }
            })
            .catch(function (error) {
              console.error(error);
            });
          }

          function selectShipping(id, pickup) {
            pickup = pickup || '';
            $rootScope.$broadcast('showPageLoader', true);
            ShippingService.selectShipping(id, pickup)
              .then(function (response) {
                if (response.status === 'OK') {
                  updateCart(response.results);
                }
                $rootScope.$broadcast('showPageLoader', false);
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function updateMobilePhone() {
            HttpService.post({
              url: '/AccountUpdateMobilePhone',
              data: {
                MobilePhone: _.replace(ctrl.shipping.userShippingCard.MobilePhone, / /g, '')
              }
            });
          }


          function checkEnabled() {
            ctrl.NextEnabled = true;
            ctrl.NextTooltip = '';
            if (ctrl.itemSelected.item.PickUp && ctrl.mobileForm && !ctrl.mobileForm.$valid) {
              ctrl.NextEnabled = false;
              ctrl.NextTooltip = tplTranslate.MobilePhoneRequired;
            }
            if (!ctrl.itemSelected.item.Address) {
              ctrl.NextEnabled = false;
              ctrl.NextTooltip = tplTranslate.NoPickupAdress;
            }
          }

        }]
      };
    })

    /* @ngInject */
    .controller('convertQuotationConnectModalCtrl', ["data", "device", "options", "$location", "$uibModalInstance", "LogService", "RoutesService", "ModalService", function (data, device, options, $location, $uibModalInstance, LogService, RoutesService, ModalService) {
      var ctrl = this;

      ctrl.register = function () {
        ModalService.close();
        LogService.redirect = {
          url: $location.path(),
          action: data.action
        };
        $location.path('/' + RoutesService.get().Login.url);
      };

      ctrl.connect = function () {
        LogService.redirect = {
          url: null,
          action: data.action
        };
        $uibModalInstance.closed.then(function () {
          ModalService.show(
            '/Template/Authentication/ModalAuthentication',
            null,
            null,
            'loginModalCtrl'
          );
        });
        $uibModalInstance.close();
      };
    }])
    .controller('modalSetShippingAddressCtrl', ["data", "device", "options", "$timeout", "HttpService", "AppService", "productsGridService", "ModalService", "toastr", function (data, device, options, $timeout, HttpService, AppService, productsGridService, ModalService, toastr) {
      var ctrl = this;
      ctrl.data = data;

      ctrl.data.Function = '';
      $timeout(function () {
        ctrl.data.selectTitle = ctrl.data.IDTitle;
        ctrl.data.selectCountry = ctrl.data.country;
        setTimeout(function () {
          $('.modal').find('select.refresh').selectpicker('refresh');
        });
      });

      var messageTitle;

      ctrl.$onInit = function () {
        if (!ctrl.data.addresses.length) {
          ctrl.activeTab = 1;
        }
        ctrl.loaded = true;
        setTimeout(function () {
          $('.modal').find('.modal-body').find('.addresses').attr('id', 'tmpSetAddress');
          productsGridService.resizeGrid('tmpSetAddress', data.device.size, false);
        }, 100);
      };

      ctrl.successMessage = function (title) {
        messageTitle = title;
      };

      ctrl.showCreateAddress = function () {
        ctrl.activeTab = 1;
        $('.modal').animate({scrollTop: 0}, 350);
      };

      ctrl.select = function (id) {
        ctrl.data.action(id);
        ModalService.close();
      };

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/AccountAddAddress',
          data: {
            Function: ctrl.data.Function,
            Company: ctrl.data.Company || '',
            IDTitle: ctrl.data.selectTitle || '',
            FirstName: ctrl.data.FirstName || '',
            LastName: ctrl.data.LastName || '',
            Address: ctrl.data.Address || '',
            EUTVANumber: ctrl.data.EUTVANumber || '',
            AddressApartment: ctrl.data.AddressApartment || '',
            AddressBuilding: ctrl.data.AddressBuilding || '',
            AddressLocality: ctrl.data.AddressLocality || '',
            PostCode: ctrl.data.PostCode || '',
            City: ctrl.data.City || '',
            IDCountry: ctrl.data.selectCountry.IDCountry || '',
            Phone: ctrl.data.Phone || '',
            MobilePhone: ctrl.data.MobilePhone || ''
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                toastr.success('', messageTitle, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                ctrl.data.action(response.results);
                ModalService.close();
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    /* @ngInject */
    .controller('modalSetUserAddressCtrl', ["data", "device", "options", "$timeout", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, $timeout, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;
      ctrl.data = data;

      $timeout(function () {
        ctrl.data.selectTitle = ctrl.data.IDTitle;
        ctrl.data.selectCountry = ctrl.data.Country;
        setTimeout(function () {
          $('.modal').find('select.refresh').selectpicker('refresh');
        });
      });

      var messageTitle;

      ctrl.successMessage = function (title) {
        messageTitle = title;
      };

      ctrl.submit = function () {
        ctrl.loading = true;

        AppService.getParams()
          .then(function (params) {
            HttpService.post({
              url: '/AccountUpdateAddress',
              data: {
                IDCard: params.Visitor.IDCard,
                Company: ctrl.data.Company || '',
                IDTitle: ctrl.data.selectTitle || '',
                FirstName: ctrl.data.FirstName || '',
                LastName: ctrl.data.LastName || '',
                EUTVANumber: ctrl.data.EUTVANumber || '',
                Address: ctrl.data.Address || '',
                AddressApartment: ctrl.data.AddressApartment || '',
                AddressBuilding: ctrl.data.AddressBuilding || '',
                AddressLocality: ctrl.data.AddressLocality || '',
                PostCode: ctrl.data.PostCode || '',
                City: ctrl.data.City || '',
                IDCountry: ctrl.data.selectCountry.IDCountry || '',
                Phone: ctrl.data.Phone || '',
                MobilePhone: ctrl.data.MobilePhone || ''
              }
            })
            .then(function (response) {
              AppService.getTranslate()
                .then(function (translate) {
                  if (response.status === 'OK') {
                    toastr.success('', messageTitle, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                    ModalService.close();
                  } else {
                    toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  }
                  ctrl.loading = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            })
            .catch(function (error) {
              console.error(error);
            });
          })
          .catch(function (error) {
            console.error(error);
          });

      };

    }]);

})();
